import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import SupplierCategory, { CategoryKeys } from '../models/SupplierCategory';

export function getSupplierCategoryAll() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_LIST_ALL,
        parser: supplierCategoriesAllDataParser,
    }).get();
}

export function getSupplierCategories(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_LIST,
        params: params,
        parser: supplierCategoriesDataParser,
    }).get();
}

export function getSupplierCategoryDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_DETAIL,
        endpointParams: { id },
        parser: data => new SupplierCategory(data.data),
    }).get();
}

export function createSupplierCategory(category) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_CREATE,
    }).post(category.export());
}

export function updateSupplierCategory(category) {
    let id = category.id || null;
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_UPDATE,
        endpointParams: { id },
    }).put(category.export());
}

export function deleteSupplierCategory(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.SUPPLIER_CATEGORY_DELETE,
        endpointParams: { id },
    }).delete();
}

function supplierCategoriesDataParser(data = {}) {
    return {
        ...data.data,
        categories: (data.data.result || []).map(item => new SupplierCategory(item))
    }
}

function supplierCategoriesAllDataParser(data = {}) {
    return {
        ...data.data,
        categories: (data.data || []).map(item => new SupplierCategory(item))
    }
}
